export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  display: block;
  -webkit-tap-highlight-color: transparent;
}
:host header {
  width: 100%;
  height: var(--slicesui-project-page-header--height, 80vh);
  background: var(--slicesui-project-page-header--background, transparent);
}
:host slicesui-carousel {
  width: 100%;
  height: var(--slicesui-project-page-carousel--height, 50vh);
  background: var(--slicesui-project-page-carousel--background, transparent);
}
:host slicesui-tab-bar {
  --slicesui-button-background: transparent;
  --slicesui-button-color: #000;
  --slicesui-button-color--active: #000;
  --slicesui-button-border-color--active: #000;
  --slicesui-button-border-radius: 0;
  --slicesui-button-border-width: 0;
  --slicesui-button-border-color: transparent;
  --slicesui-tab-bar-button--margin: 0 20px 0 0;
  margin-bottom: 20px;
}
:host main {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  margin: 0;
  font-family: var(--slices-text-b1--font-family, var(--slices-text-b--font-family, var(--slices-text--font-family)));
  font-size: var(--slices-text-b1--font-size);
  font-weight: var(--slices-text-b1--font-weight, var(--slices-text-b--font-weight, 400));
  line-height: var(--slices-text-b1--line-height, var(--slices-text-b--line-height));
  width: 1280px;
  max-width: 100%;
  margin: 20px auto;
  padding: var(--erem);
  background: var(--slicesui-project-page-main--background, transparent);
}
:host main article {
  width: 768px;
  max-width: 100%;
  margin: 0;
}
:host ::slotted(article) {
  display: none;
  font-size: 0;
}
:host footer {
  width: 100%;
  height: 40vh;
  background: var(--slicesui-project-page-footer-background, transparent);
}
:host #languageSwitch {
  position: absolute;
  top: var(--erem);
  right: var(--erem);
  z-index: 1;
  display: flex;
  align-items: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  margin: 0;
  font-family: var(--slices-text-b1--font-family, var(--slices-text-b--font-family, var(--slices-text--font-family)));
  font-size: var(--slices-text-b1--font-size);
  font-weight: var(--slices-text-b1--font-weight, var(--slices-text-b--font-weight, 400));
  line-height: var(--slices-text-b1--line-height, var(--slices-text-b--line-height));
  color: var(--slicesui-project-page-language-switch--color);
}
:host #languageSwitch slicesui-toggle {
  margin: 0 8px;
}
:host #storyContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  transition: transform 1000ms cubic-bezier(0.075, 0.82, 0.165, 1), transform 1000ms cubic-bezier(0.075, 0.82, 0.165, 1), opacity 1000ms ease;
  transform-origin: 50% 50%;
  transform: scale(2);
  z-index: 4;
  opacity: 0;
  pointer-events: none;
}
:host #storyContainer iframe {
  border: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  display: block;
  opacity: 0;
  transition: 500ms opacity ease;
  z-index: 2;
}
:host #storyContainer[data-loaded] iframe {
  opacity: 1;
  pointer-events: all;
}
:host #storyContainer #close {
  position: fixed;
  top: var(--erem);
  left: var(--erem);
  --slicesui-button-background: rgba(0,0,0,0.2);
  --slicesui-button-color: #fff;
  z-index: 3;
  pointer-events: all;
}
:host([selected-story]) #storyContainer {
  transform: scaleY(1);
  opacity: 1;
}
@-moz-keyframes rotate {
  from {
    transform: rotate(0);
    transform-origin: center;
  }
  to {
    transform: rotate(360deg);
    transform-origin: center;
  }
}
@-webkit-keyframes rotate {
  from {
    transform: rotate(0);
    transform-origin: center;
  }
  to {
    transform: rotate(360deg);
    transform-origin: center;
  }
}
@-o-keyframes rotate {
  from {
    transform: rotate(0);
    transform-origin: center;
  }
  to {
    transform: rotate(360deg);
    transform-origin: center;
  }
}
@keyframes rotate {
  from {
    transform: rotate(0);
    transform-origin: center;
  }
  to {
    transform: rotate(360deg);
    transform-origin: center;
  }
}
`;